export const getDefaultST = (loginState: any) => {
    const shipTos = loginState?.user?.allShipToBillToAddresses;
    const defaultST = shipTos?.find((st: any) => st.shipTo?.isDefault);
    return defaultST;
  };

  export const getSTByAccountNumber = (loginState: any, accountNumber?: string | null) => {
    if (!accountNumber) return null;
    const shipTos = loginState?.user?.allShipToBillToAddresses;
    return (
      shipTos?.find(
        (st: any) => st.shipTo?.accountNumber?.toString() === accountNumber.toString()
      ) || null
    );
  };

  export const getInitialSelectedAddressKey = (
    loginState: any,
    currentST?: string | null
  ) => {
    const matchedST = getSTByAccountNumber(loginState, currentST);
    if (matchedST?.shipTo?.addressKey) {
      return matchedST.shipTo.addressKey.toString();
    }
    const defaultST = getDefaultST(loginState);
    return defaultST?.shipTo?.addressKey?.toString() || "";
  };
  
  export const getSelectedST = (loginState: any) => {
    // localStorage.getItem('selectedAddressKey')
    const selectedAddressKey = localStorage.getItem('selectedAddressKey') || '';
    const shipTos = loginState?.user?.allShipToBillToAddresses;
    let selectedST = shipTos?.find(
      (st: any) => st.shipTo?.addressKey?.toString() === selectedAddressKey
    );
    // shipTo, billTos,
    if (selectedST) {
      return selectedST;
    }
    selectedST = getDefaultST(loginState);
    return selectedST;
  };
  
  export const getSelectedSTObj = (loginState: any) => {
    const selectedST = getSelectedST(loginState);
    return selectedST?.shipTo;
  }
  
  export const getSelectedBTObj = (loginState: any) => {
    if (loginState.status !== 'login') return null;
    const selectedST = getSelectedST(loginState);
    const selectedBTNumber = selectedST?.shipTo.relatedBillTo;
    let selectedBT = selectedST?.billTos?.find(
      (bt: any) =>
        bt.accountNumber === selectedBTNumber
    );
    if (!selectedBT) { 
      selectedST.billTos?.find((bt: any) => bt.isDefault)
    }
    if (!selectedBT) {
      selectedBT = selectedST.billTos[0]
    }
    return selectedBT;
  
  };
  export const getSTAddress = (STObj: any) => {
    if (!STObj) return "";
    const { city, streetAddress, buildingOrRoom, deptOrLab} = STObj;
    let str = city || ''
    str += streetAddress ? `, ${streetAddress}` : ''
    str += buildingOrRoom ? `, ${buildingOrRoom}` : ''
    str += deptOrLab ? `, ${deptOrLab}` : ''
    return str;
  }
  export const getBTAddress = (BTObj: any) => {
    if (!BTObj) return "";
    return getSTAddress(BTObj);
    // const { country, state, city, streetAddress, buildingOrRoom, deptOrLab} = BTObj;
    // return `${country} ${state || ''} ${city} ${streetAddress} ${buildingOrRoom} ${deptOrLab}`;
  }
  export const parseAttentionTo = (attentionTo:any) => {
	if (!attentionTo) return null
  if (attentionTo.split('，').length === 2) {
    return attentionTo.split('，')
  }
	if (attentionTo.split(',').length === 2) {
		return attentionTo.split(',')
	} 
  const pattName = /[\u4e00-\u9fa5_a-zA-Z_\s]*/
  const pattPhone = /[0-9_\+]*$/
  const name = pattName.exec(attentionTo)
  const phone = pattPhone.exec(attentionTo)
  return [name && name[0]?.replace(/(\s*$)/g, ""), phone && phone[0]]
}
  
 export const getContactName = (STObj: any, userData: any) => {
    if (!STObj) return "";
    const { attentionTo } = STObj;
    let name = STObj.nickName;
    const user = userData?.user;
    const parsedValue:any = parseAttentionTo(attentionTo)
    if (!name) {
        if (parsedValue) {
            const [nickName,] = parsedValue
            name = nickName
        }
        if (!name) {
            name = user?.lastName + user?.firstName;
        }
    }
    return name;
 }

export const getSTDefaultContact = (loginState:any) => {
  const userInfo = loginState?.user?.user;
  const lastName = userInfo?.lastName || "";
  const firstName = userInfo?.firstName || "";
  return {name: `${lastName}${firstName}`, phone: userInfo?.contactInfo?.phone || ""};
};
 export const getContactPhone = (STObj: any, userData: any) => {
    if (!STObj) return "";
    const { attentionTo } = STObj;
    let phone = STObj.phoneNumber;
    const user = userData?.user;
    const parsedValue:any = parseAttentionTo(attentionTo)
    if (!phone) {
        if (parsedValue) {
            const [, phoneNumber] = parsedValue
            phone = phoneNumber
        }
        if (!phone) {
            phone = user?.contactInfo?.phone || '';
        }
    }
    return phone;
 }

// Extended phone extractor for confirm-channel dropdown (does not change original behaviors)
export const getContactPhoneForChannel = (STObj: any, userData: any) => {
  if (!STObj) return "";
  const user = userData?.user;
  const { attentionTo } = STObj;
  const parsedValue: any = parseAttentionTo(attentionTo);
  const candidates = [
    STObj.phoneNumber,
    STObj.phone,
    STObj.contactPhone,
    STObj.mobilePhone,
    STObj.mobile,
    parsedValue && parsedValue[1],
    user?.contactInfo?.phone,
  ];
  const phone = candidates.find((p) => !!p);
  return phone || "";
};

  export const getContact = (STObj: any, userData: any) => {
    if (!STObj) return "";
    const { attentionTo } = STObj;
    
    let name = STObj.nickName;
    let phone = STObj.phoneNumber;
    const user = userData?.user;
    const parsedValue:any = parseAttentionTo(attentionTo)
    if (!name) {
        if (parsedValue) {
            const [nickName,] = parsedValue
            name = nickName
        }
        if (!name) {
            name = user?.lastName + user?.firstName;
        }
    }
    if (!phone) {
        if (parsedValue) {
            const [, phoneNumber] = parsedValue
            phone = phoneNumber
        }
        if (!phone) {
            phone = user?.contactInfo?.phone || '';
        }
    }
    return `${name},${phone}`;
  }
//   export const getBTContact = (BTObj: any, userData: any) => {
//     if (!BTObj) return "";
//     let name = BTObj.nickName;
//     let phone = BTObj.phoneNumber;
//     const user = userData?.user;
//     if (!name) {
//       name = user?.lastName + user?.firstName;
//     }
//     if (!phone) {
//       phone = user?.phone || '';
//     }
//     return `${name} ${phone}`;
//   }
export const validateContact = (contact: string) => {
    // name, phone
    if (!contact) return {isValid: false, value: "", errMsg: "联系人信息不能为空"};
    if (contact.length > 50) return {isValid: false, value: "", errMsg: "联系人信息最多可输入50个字符"};
    const hasComma1 = contact.includes("，");
    const hasComma2 = contact.includes(",");
    const hasPlus = contact.includes("+");
    let arr = [];
    if (hasComma1) {
      arr = contact.split("，");
    } else if (hasComma2) {
      arr = contact.split(",");
    } else if (hasPlus) {
        arr = contact.split("+");
    } else {
      arr = contact.split(" ");
    }
    const filteredArr = arr.filter((item) => !!item.trim());
    const isValid =  filteredArr && filteredArr.length === 2;
    return {isValid, value: filteredArr?.join(",")};
  }
  export const isValidChinesePhoneNumber = (phone: string) => {
    const pattern = /^1[3-9]\d{9}$/;
    return pattern.test(phone);
  }
  // 支持可选的 +86 / 86 前缀的手机号校验
  export const isValidChinesePhoneWithCountryCode = (phone: string) => {
    if (!phone) return false;
    // 去除空格和短横线，方便校验诸如 "86 150..."、"+86 150..."、"86-150..." 等格式
    const normalized = phone.trim().replace(/[\s-]/g, "");
    const pattern = /^(\+?86)?1[3-9]\d{9}$/;
    return pattern.test(normalized);
  }

  export const getSwithcSTAddress = (STObj: any) => {
    if (!STObj) return "";
    
    const addressParts = [
      STObj.state,
      STObj.city,
      STObj.streetAddress,
      STObj.buildingOrRoom,
      STObj.deptOrLab,
    ];
  
    return addressParts
      .filter((part) => part)
      .join(", ");
  }  
  
  export const getUserName = (STObj: any, userData: any) => {
    if (!STObj) return "";
    const { attentionTo } = STObj;
   
    const user = userData?.user;

    if (attentionTo && attentionTo.split(',').length > 1) {
      STObj.nickName = attentionTo.split(',')[0];
    } else if (typeof attentionTo === "string") {
      STObj.nickName = STObj.nickName
        ? STObj.nickName
        : STObj.attentionTo;
    } else {
      STObj.nickName = user?.lastName + user?.firstName
    }
    return STObj.nickName;
  }
 
  export const getUserPhone = (STObj: any, userData: any) => {
    if (!STObj) return "";
    const { attentionTo } = STObj;
   
    let phone = STObj.phone;
    const user = userData?.user;
    if (!phone) {
        if (attentionTo && attentionTo.split(',').length > 1) {
          phone = attentionTo.split(',')[1];
        } else if (typeof attentionTo === "string") {
          phone = attentionTo;
        } else {
          phone = user?.contactInfo?.phone || '';
        }
    }
    return phone;
  }
